export const NAME = "offerRequests"
export const FIREBASE_PATH = "offerRequests"
